module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"create":"Add a new record","maintenancePolicies":"Maintenance policies"},"de":{"create":"Neuen Wartungssatz hinzufügen","maintenancePolicies":"Wartungspläne"},"fr":{"create":"Ajouter un nouvel de maintenance","maintenancePolicies":"Politiques de maintenance"},"it":{"create":"Aggiungere un nuovo record","maintenancePolicies":"Politiche di manutenzione"}}')
  delete Component.options._Ctor
}
